export const IOC_TYPES = [
  { id: "url", label: "URLs", short: "URL", color: "#36a2eb" },
  { id: "domain", label: "Domains", short: "Domain", color: "#a77bdb" },
  { id: "ip", label: "IP addresses", short: "IP", color: "#e69b55" },
  { id: "hash", label: "Hashes", short: "Hash", color: "#3fb6c9" },
];

// Same ids as the backend windows
export const WINDOW_OPTIONS = [
  { id: "24-hour", value: "24 hours", label: "last 24 hours" },
  { id: "7-day", value: "7 days", label: "last 7 days" },
  { id: "30-day", value: "30 days", label: "last 30 days" },
  { id: "90-day", value: "90 days", label: "last 90 days" },
];

export const DEFAULT_WINDOW = WINDOW_OPTIONS[2];

export const windowLabel = (id) =>
  (WINDOW_OPTIONS.find((option) => option.id === id) || DEFAULT_WINDOW).label;

export const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (isNaN(date)) return value;
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Timeline keys are "YYYY-MM-DD" days or "YYYY-MM-DDTHH:00" hours, already in
// the viewer's time zone
export const bucketLabel = (key, unit) => {
  if (unit === "hour") return key.slice(11, 16);
  const [year, month, day] = key.split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
};
